import React, {useLayoutEffect, useState} from "react";
import Dashboard from "./Dashboard";
import OrdersDetails from "./OrdersDetails";
import MangeDashboard from "./MangeDashboard";

import {useMediaQuery} from "beautiful-react-hooks";
import { useAuthState } from "../../Context/auth-context";



export function DirOrder() {
    const phone = sessionStorage.getItem('user');
    const [auth,setAuth] =  useState(false);
    const isSmall = useMediaQuery('(max-width: 768px)')
    const {isAuth} = useAuthState()


  


    return(
        <>
        <MangeDashboard>


            {isSmall ? 

            <div className={'list-report'}>

                {isAuth ?

                    <OrdersDetails phone={phone} auth={isAuth} />

                :
                    <OrdersDetails phone={phone} auth={isAuth} />


                }

            </div>

            :
            <div className={'list-report'}>

            {isAuth ?

                <OrdersDetails phone={phone} auth={isAuth} />

            :
                <OrdersDetails phone={phone} auth={isAuth} />


            }

        </div>


         }

        </MangeDashboard>
        </>

    )

}